<script>
import { Line } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Line,
    data() {
        var dates = this.properties;
        var labels = dates;
        var that = this;
        var datelist = _.keyBy(dates, 'inspection_id')
        var series = _.keys(datelist);
        var vals = _.values(datelist);
        var label = this.$t('routine_analyses.graphs.activity');
        return {
            chartData: {
                datasets: [{
                        axis: 'y',
                        label: label,
                        data: _.map(series, (c) => { return datelist[c].conditions; } ),
                        fill: false,
                        borderColor: that.color,
                        backgroundColor: that.color,
                        borderWidth: 1
                }],
                labels: _.map(series, (c) => { return moment(datelist[c].date).format('D.M.YYYY'); } )
            },
            options: {
                scales: {
                    yAxes: [{
                       ticks: {
                            stepSize: 1,
                            beginAtZero: true,
                            max: 4
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            stepSize: 1
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: false
                },
                spanGaps: false,
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        properties: Array,
        color: String,
        orderby: String,
        mode: String
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>